export enum QuestionTypes {
  shortText = "SHORT_TEXT",
  extendedText = "EXTENDED_TEXT",
  multipleChoice = "MULTIPLE_CHOICE"
}
